export const FORM_KEY = 'broye';
export const NETWORK_NAME = 'le Réseau Santé Social de la Broye Fribourgeoise';
export const DISTRICT_NAME = 'la Broye';
export const LANG = 'fr';
export const YES = 'Oui';
export const NO = 'Non';
export const NURSING_HOME_LOCATION_ID = '156402';

export const ADMIN_REP_TITLES = [
  {
    'id': '156358',
    'label': 'Madame'
  },
  {
    'id': '156359',
    'label': 'Monsieur'
  }
];
export const ADMIN_REP_OFFICIAL_MEASURES = [
  {
    'id': '156360',
    'label': 'Aucune curatelle'
  },
  {
    'id': '156361',
    'label': 'Candidat sous curatelle'
  },
  {
    'id': '156362',
    'label': 'Demande de curatelle en cours'
  }
];
export const BENEFITS_SERVICES = [
  {
    'id': '156374',
    'label': 'PC domicile'
  },
  {
    'id': '156375',
    'label': 'PC Home'
  }
];

export const CANDIDATE_TITLES = [
  {
    id: 156389,
    label: 'Madame'
  },
  {
    id: 156390,
    label: 'Monsieur'
  }
];

export const CANDIDATE_STATES = [
  {
    'id': '156318',
    'label': 'Argovie - Aargau'
  },
  {
    'id': '156319',
    'label': 'Appenzell Rhodes intérieures - Inner-Rhoden'
  },
  {
    'id': '156320',
    'label': 'Appenzell Rhodes extérieures - Ausser-Rhoden'
  },
  {
    'id': '156321',
    'label': 'Berne - Bern'
  },
  {
    'id': '156322',
    'label': 'Bâle Campagne - Basel Land'
  },
  {
    'id': '156323',
    'label': 'Bâle Ville - Basel Stadt'
  },
  {
    'id': '156324',
    'label': 'Fribourg - Freiburg'
  },
  {
    'id': '156325',
    'label': 'Genève - Genf'
  },
  {
    'id': '156326',
    'label': 'Glaris - Glarus'
  },
  {
    'id': '156327',
    'label': 'Grisons - Graubuenden'
  },
  {
    'id': '156328',
    'label': 'Jura'
  },
  {
    'id': '156329',
    'label': 'Lucerne -Luzern'
  },
  {
    'id': '156330',
    'label': 'Neuchâtel - Neuenburg'
  },
  {
    'id': '156331',
    'label': 'Nidwald - Nidwalden'
  },
  {
    'id': '156332',
    'label': 'Obwald - Obwalden'
  },
  {
    'id': '156333',
    'label': 'Saint-Gall - Sankt Gallen'
  },
  {
    'id': '156334',
    'label': 'Schaffhouse - Schaffausen'
  },
  {
    'id': '156335',
    'label': 'Soleure - Solothurn'
  },
  {
    'id': '156316',
    'label': 'Schwyz'
  },
  {
    'id': '156317',
    'label': 'Thurgovie - Thurgau'
  },
  {
    'id': '156336',
    'label': 'Ticino - Tessin'
  },
  {
    'id': '156337',
    'label': 'Uri'
  },
  {
    'id': '156338',
    'label': 'Vaud - Waadt'
  },
  {
    'id': '156339',
    'label': 'Valais - Vallis'
  },
  {
    'id': '156340',
    'label': 'Zug'
  },
  {
    'id': '156341',
    'label': 'Zurich - Zürich'
  }
];

export const CANDIDATE_STATUS = [
  {
    'id': '156342',
    'label': 'Célibataire'
  },
  {
    'id': '156343',
    'label': 'Marié(e)'
  },
  {
    'id': '156346',
    'label': 'Divorcé(e)'
  },
  {
    'id': '156344',
    'label': 'Veuf(ve)'
  },
  {
    'id': '156345',
    'label': 'Séparé(e)'
  }
];


export const COMPLEMENTARY_INSURANCE_TYPES = [
  {
    'id': '156365',
    'label': 'Privé'
  },
  {
    'id': '156366',
    'label': 'Autre'
  },
  {
    'id': '156367',
    'label': 'Demi-privé'
  }
];


export const RELATIVE1_TITLES = [
  {
    'id': '156354',
    'label': 'Madame'
  },
  {
    'id': '156355',
    'label': 'Monsieur'
  }
];

export const RELATIVE2_TITLES = [
  {
    'id': '156352',
    'label': 'Madame'
  },
  {
    'id': '156353',
    'label': 'Monsieur'
  }
];


export const SITUATION_LOCATIONS = [
  {
    'id': '156399',
    'label': 'Domicile'
  },
  {
    'id': '156400',
    'label': 'Hôpital'
  },
  {
    'id': '156401',
    'label': 'SEO'
  },
  {
    'id': '156402',
    'label': 'EMS'
  }
];
export const SITUATION_LIVES_WITH = [
  {
    'id': '156347',
    'label': 'Seul(e)'
  },
  {
    'id': '156348',
    'label': 'Avec conjoint'
  },
  {
    'id': '156349',
    'label': 'Avec enfant(s)'
  },
  {
    'id': '156350',
    'label': 'Animaux de compagnie'
  },
  {
    'id': '156351',
    'label': 'Autre'
  }
];

export const STAY_REQUEST_TYPES = [
  {
    'id': '156383',
    'label': 'Court séjour'
  },
  {
    'id': '156382',
    'label': 'Long séjour'
  },
  {
    'id': '156470',
    'label': 'Séjour de répit'
  },
  {
    'id': '156384',
    'label': 'Foyer de jour'
  },
  {
    'id': '156385',
    'label': 'Unité spécialisée en démence'
  },
  {
    'id': '156386',
    'label': `SEO`
  },
  {
    'id': '156468',
    'label': `PAA (psychiatrie de l'âge avancé)`
  },
  {
    'id': '156469',
    'label': `Demande d'aide et de soins`
  },
];
export const STAY_REQUEST_ENTRIES = [
  {
    'id': '156378',
    'label': 'immédiate'
  },
  {
    'id': '156379',
    'label': '1 mois'
  },
  {
    'id': '156380',
    'label': '3 mois'
  },
  {
    'id': '156381',
    'label': '6 mois'
  }
];

export const NURSING_HOME_2_OPTIONAL_STAY_TYPES: string[] = [];

export const STAY_REQUEST_NURSING_HOME1 = [
  {
    'id': 156403,
    'label': 'EMS Les Fauvettes',
    'stay_types': [156383, 156382, 156470, 156384]
  },
  {
    'id': 156404,
    'label': 'EMS Les Lilas',
    'stay_types': [156382, 156470]
  },
  {
    'id': 156405,
    'label': 'EMS Les Mouettes',
    'stay_types': [156382, 156470, 156384]
  },
  {
    'id': 156406,
    'label': 'Les Grèves du Lac',
    'stay_types': [156383, 156382, 156470, 156385, 156468]
  },
  {
    'id': 156407,
    'label': 'Soins à domicile',
    'stay_types': [156469]
  }
];
export const STAY_REQUEST_NURSING_HOME2 = [
  {
    'id': 156408,
    'label': 'EMS Les Fauvettes',
    'stay_types': [156383, 156382, 156470, 156384]
  },
  {
    'id': 156409,
    'label': 'EMS Les Lilas',
    'stay_types': [156382, 156470]
  },
  {
    'id': 156410,
    'label': 'EMS Les Mouettes',
    'stay_types': [156382, 156470, 156384]
  },
  {
    'id': 156411,
    'label': 'Les Grèves du Lac',
    'stay_types': [156383, 156382, 156470, 156385, 156468]
  },
  {
    'id': 156412,
    'label': 'Soins à domicile',
    'stay_types': [156469]
  }
];


export const THERAPEUTIC_REP_TITLES = [
  {
    'id': '156356',
    'label': 'Madame'
  },
  {
    'id': '156357',
    'label': 'Monsieur'
  }
];
